<template>
    <div class="tpl-page-container">
        <SideBar></SideBar>
        <MainView></MainView>
    </div>
</template>

<script type="text/javascript">
    import SideBar from '@/components/common_components/side_bar/side_menu.vue'
    import MainView from '@/apps/plan/sub_components/view_plan.vue'
    export default {
        components: {
            SideBar,
            MainView,
        },
    }
</script>
<style type="text/css">
</style>
